function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import compact from 'lodash/compact';
import cn from 'classnames';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import toUpper from 'lodash/toUpper';
import Asset from '../Asset';
import styles from './Avatar.pcss';
var _React_PureComponent;
class Avatar extends (_React_PureComponent = React.PureComponent) {
    get plainName() {
        const { name } = this.props;
        if (!name) {
            return '';
        }
        if (isArray(name)) {
            return name.join(' ').trim();
        }
        return name.trim();
    }
    get hslColor() {
        const name = this.plainName;
        if (!name) {
            return null;
        }
        let hash = 0;
        for(let i = 0; i < name.length; i++){
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const h = hash % 360;
        return `hsl(${h}, 70%, 80%)`;
    }
    renderInitials() {
        const { initialsNo } = this.props;
        let { name } = this.props;
        if (!name || isEmpty(name)) {
            return null;
        }
        const initials = [];
        if (!isArray(name)) {
            name = name.split(' ');
        }
        const cname = compact(name);
        for(let i = 0; i < Math.min(initialsNo, cname.length); i++){
            initials.push(toUpper(cname[i][0]));
        }
        return /*#__PURE__*/ _jsx("div", {
            className: cn(this.props.initialsClassName),
            children: initials.join('')
        });
    }
    render() {
        const { avatarImg, className, imgClassName } = this.props;
        const classNames = cn(styles.avatar__initials_container, imgClassName);
        const avatar = avatarImg ? /*#__PURE__*/ _jsx(Asset, {
            className: cn(imgClassName),
            src: avatarImg,
            alt: this.plainName
        }) : /*#__PURE__*/ _jsx("div", {
            className: classNames,
            style: {
                backgroundColor: this.hslColor
            },
            children: this.renderInitials()
        });
        return /*#__PURE__*/ _jsx("div", {
            className: cn(className),
            children: avatar
        });
    }
}
_define_property(Avatar, "propTypes", {
    // Explicit props
    avatarImg: PropTypes.string,
    name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    initialsNo: PropTypes.number,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    imgClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    initialsClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
});
_define_property(Avatar, "defaultProps", {
    initialsNo: 2
});
export default withStyles(styles)(Avatar);
